import React, { useEffect } from "react";
import { Layout, ConfigProvider } from "antd";
import { BrowserRouter as Router } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import get from "lodash/get";

import LayoutSider from "./components/layout/LayoutSider";
import LayoutHeader from "./components/layout/LayoutHeader";

import AuthRouter from "./router/AuthRouter";
import UserRouter from "./router/UserRouter";
import SettingRouter from "./router/SettingRouter";
import ReportRouter from "./router/ReportRouter";

import {  userDetails } from "./redux/actions/authActions";
import { permissions } from "./redux/actions/permissionActions";
import { themeConfig } from "./constants/themeConfig";

const { Content } = Layout;

const AppRouter = () => {
  const isLoggedIn = useSelector((state) => get(state, "auth.isLoggedIn"));
  const dispatch = useDispatch();

  const getUserDetails = () => {
    dispatch(userDetails())
      .then(() => {})
      .catch(() => {});
  };

  const getPermissions =()=>{
    dispatch(permissions())
    .then(()=> {})
    .catch(()=>{})
  }
  
  useEffect(() => {
    if (isLoggedIn) {
      getUserDetails();
      getPermissions()
    }
  }, [isLoggedIn]);

  return (
    <ConfigProvider theme={themeConfig}>
      <Layout hasSider className="bg-[#EEF0FA] min-h-screen h-screen">
        <Router>
          {isLoggedIn && <LayoutSider />}

          {/* Main Layout */}
          <Layout className="bg-[#EEF0FA]">
            {/* Fixed Header */}
            {isLoggedIn && <LayoutHeader />}

            {/* Scrollable Content */}
            <Content
              className="ml-2 mr-4 py-4 overflow-auto custom-scrollbar"
              style={{
                height: "calc(100vh - 64px)",
              }}
            >
              <AuthRouter />
              <SettingRouter />
              <UserRouter />
              <ReportRouter />
            </Content>
          </Layout>
        </Router>
      </Layout>
    </ConfigProvider>
  );
};

export default AppRouter;
